import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, dt } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STAGES = ["Intro", "Follow Up", "Information Sent", "Qualified Lead", "Quote", "Won", "Not Interested"];
const CHANNELS = ["Call", "Email", "Visit", "Other"];

function Pick({ value, options, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export function EditSubmission({ activity, onClose, onSaved }) {
  const [f, setF] = useState(null);
  useEffect(() => {
    if (activity) setF({ channel: activity.channel, stage: activity.stage, summary: activity.summary, follow_up_date: activity.follow_up_date || "" });
  }, [activity]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/activities/${activity.id}`, { ...f, follow_up_date: f.follow_up_date || null });
      toast.success("Submission updated – change recorded in audit trail");
      onSaved();
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={!!activity} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Update submission – {activity?.account_name}</DialogTitle></DialogHeader>
        {f && (
          <form onSubmit={save} className="space-y-4" data-testid="edit-submission-form">
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label>Contact type</Label><Pick value={f.channel} options={CHANNELS} onChange={(v) => setF({ ...f, channel: v })} testId="edit-channel-select" /></div>
              <div className="space-y-1.5"><Label>Stage</Label><Pick value={f.stage} options={STAGES} onChange={(v) => setF({ ...f, stage: v })} testId="edit-stage-select" /></div>
            </div>
            <div className="space-y-1.5"><Label>Follow-up date</Label><Input type="date" value={f.follow_up_date} onChange={(e) => setF({ ...f, follow_up_date: e.target.value })} data-testid="edit-followup-date" /></div>
            <div className="space-y-1.5"><Label>Summary</Label><Textarea required rows={4} value={f.summary} onChange={(e) => setF({ ...f, summary: e.target.value })} data-testid="edit-summary-input" /></div>
            {activity?.edits?.length > 0 && (
              <div className="text-xs text-slate-500 border-t pt-3 max-h-32 overflow-y-auto" data-testid="edit-history">
                <p className="font-semibold mb-1">Change history</p>
                {activity.edits.map((h, i) => <p key={i} className="font-mono">{h.by} · {dt(h.at)} — {h.changes.join("; ")}</p>)}
              </div>
            )}
            <Button type="submit" className="w-full bg-[#D9232A] hover:bg-[#B81920]" data-testid="edit-submission-save-btn">Save update</Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
